import React from 'react'
import {
  BlogMajor,
  ChecklistMajor,
  FinancesMajor,
  FraudProtectMajor,
  JobsMajor,
  StoreMajor,
} from '@shopify/polaris-icons'
import {
  CustomerCollectedDataType,
  CustomerCollectedDataTypeExtended,
  CustomerMCLinkInfoType,
  CustomerResubmitInfoType,
} from './enums'
import { GSIcon } from 'src/components/shared/GSIcon'

export const customerComplianceStepIcons: Record<CustomerCollectedDataTypeExtended, any> = {
  [CustomerCollectedDataType.Insurance]: <FraudProtectMajor width={20} />,
  [CustomerCollectedDataType.BusinessDetails]: <StoreMajor width={20} />,
  [CustomerCollectedDataType.GigsafeContract]: <BlogMajor width={20} />,
  [CustomerResubmitInfoType.PaymentInfo]: <FinancesMajor width={20} />,
  [CustomerResubmitInfoType.BusinessInfo]: <JobsMajor width={20} />,
  [CustomerMCLinkInfoType.SignContract]: <BlogMajor width={20} />,
  [CustomerCollectedDataType.TSA]: <ChecklistMajor width={20} />,
  [CustomerResubmitInfoType.PaymentMethod]: <GSIcon iconName="gs_wallet_3" width={20} />,
} as const
